import React from "react";

const HeroOneColumn = (props: {
    body: React.ReactNode,
    backgroundImage?: string,
    maxWidth: number
}) => {
    return (
        <section
            className="layout layout--hero-one-column"
            style={{
                background: props.backgroundImage ? `url(${ props.backgroundImage }) center/cover no-repeat #000000` : "#000000",
            }}
        >
            <div className="layout__inner" style={{ maxWidth: `calc(${ props.maxWidth }rem/16)` }}>
                {props.body}
            </div>
        </section>
    );
};

export default HeroOneColumn;
